module.exports = __webpack_public_path__ + "static/media/Mattie.e97199f9.jpg";